import ShippingCalculator from "../Pages/ShippingCalculator/ShippingCalculator";
import NotFound from "../Pages/NotFound";

const GenericRoutes = [
    {
        path: '*',
        element: <NotFound />
    }
]

export default GenericRoutes